module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/mapbox.js/~/isarray/index.js
 ** module id = 940
 ** module chunks = 0 1 3 4 5 6
 **/